<highcharts-chart  [Highcharts]="Highcharts" [options]="chartOptions">
</highcharts-chart>